import React from 'react';
//import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import { createRoot } from 'react-dom/client';
import rootReducer from './reducers'
import {Provider} from 'react-redux'

const store = configureStore({reducer:rootReducer});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render( 
  <Provider store={store}>
  <App />
</Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
